import { ReportLayout } from '../../../vas/business-objects/report-layout/report-layout.model';
import { Report } from '../../../vas/business-objects/report/report.model';
import * as actions from './job-print.actions';

export interface State {
    reportLayouts: Array<ReportLayout>;
    reports: Array<Report>;
}

export const initialState: State = {
    reportLayouts: [],
    reports: []
};

// tslint:disable-next-line:only-arrow-functions
export function reducer(state = initialState, action: actions.Actions): State {
    switch (action.type) {
        case actions.INIT: {
            return {
                reportLayouts: [],
                reports: []
            };
        }
        case actions.REMOVE_REPORT: {
            return {
                ...state,
                reports: state.reports
                    .filter(r => r. id !== action.payload.id)
            };
        }
        case actions.SET_REPORT_LAYOUTS: {
            return {
                ...state,
                reportLayouts: action.payload.reportLayouts
            };
        }
        case actions.SET_REPORTS: {
            return {
                ...state,
                reports: action.payload.reports
            };
        }
        default: {
            return state;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/job-print/job-print.reducer.ts